module.exports = __webpack_public_path__ + "img/juno-dark.65144945.svg";